export enum ProjetType {
    AUDIT = 'audit',
    AUDIT_INSPECTION = 'auditInspection',
    INSPECTION = 'inspection',
}
